<template>
  <v-layout row wrap>
    <v-flex offset-md1 md5>
      <v-btn
      round
      large
      dark
      class="btn-green no-transform"
      @click.native.stop="itemEscolha('')">
        <span class="pr-1">
          <v-icon dark>add_circle_outline</v-icon>
        </span>
        Novo item
      </v-btn>
    </v-flex>

    <v-flex md5>
      <v-btn
      round
      large
      dark
      class="btn-blue no-transform"
      @click.native.stop="filterActive(2)">
        Todos
      </v-btn>
      <v-btn
      round
      large
      dark
      class="btn-green no-transform"
      @click.native.stop="filterActive(1)">
        Ativos
      </v-btn>
      <v-btn
      round
      large
      dark
      class="btn-red no-transform"
      @click.native.stop="filterActive(0)">
        Inativos
      </v-btn>
      <v-text-field xs12 sm6 md3
      label="Pesquisar itens"
      v-model="searchItem"
      class="searchInput"
      append-icon="search"
      ></v-text-field>
    </v-flex>

    <v-flex offset-md1 md10>
      <v-container grid-list-xl pa-0>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 v-for="item of filteredItens" :key="item.id">
            <ItemCard :value="item"/>            
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>

    <v-flex>      
      <ItemDetalhes />
    </v-flex>
  </v-layout>
</template>

<script>
import ItemCard from '../sharedComponents/item/card'
import ItemDetalhes from './itemDetalhes'

export default {
  name: 'Relacao',
  components: {
    ItemCard,
    ItemDetalhes
  },
  data () {
    return {
      searchItem: '',
      active: 2
    }
  },
  computed: {
    filteredItens () {
      if (this.searchItem === '') {
        return this.registeredItems.filter(elem => { return (this.active === 2 || (elem.active === (this.active === 1))) })
      } else {
        return this.registeredItems.filter(elem => {
          let exp = new RegExp(this.searchItem.trim(), 'i')
          let searchItem = elem.description +
            elem.name +
            elem.tags.join()
          if (elem.priceVariations) {
            searchItem = searchItem + elem.priceTable.map(elemRow => elemRow.price + ' ' + elemRow.priceRef + ' ' + elemRow.description).join()
          } else {
            searchItem = searchItem + elem.price
          }
          return exp.test(searchItem) && (this.active === 2 || (elem.active === (this.active === 1)))
        })
      }
    },
    registeredItems () {
      return this.$store.getters.registeredItems
    }
  },
  methods: {
    itemEscolha (item) {
      this.$store.dispatch('selectItem', item)
    },
    filterActive (type) {
      this.active = type
    }
  },
  mounted () {
    this.$store.dispatch('getItems')
    this.$store.dispatch('loadCategories')
    this.$store.dispatch('loadPayments')
  }
}
</script>

<style>
  .no-transform{
    text-transform: inherit!important;
  }
  .box-variacao i{
    cursor: pointer
  }
</style>



// WEBPACK FOOTER //
// relacao.vue?766914e2